import { useEffect } from 'react';
import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { USER_STATUSES } from '@/helpers/constants';
import { SuspendResidenceWarning } from '@/components/Warnings/SuspendResidenceWarning';
import AnalyticsGA from '@/analyticsGA';
import { useGetMe } from '@/hooks/useGetMe';
import { LinkedBankAccounts } from './components/LinkedBankAccounts';
import s from './index.module.scss';

const FundsBankAccountsPage = () => {
  const { user } = useGetMe();

  useEffect(() => {
    AnalyticsGA.pageNavigation('Bank Accounts', 'finance_operations');
  }, []);

  if (user?.status === USER_STATUSES.suspended) {
    return (
      <div className={s.wrapper}>
        <SuspendResidenceWarning />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <LinkedBankAccounts />
      <MiniFaqs source={MINIFAQ_SOURCES.bankDetails} />
    </div>
  );
};

export default FundsBankAccountsPage;
